import { ITab } from '@common/components/Tabs';
import { getRoute } from '@common/constants/CampusRoutes';

type Translate = (key: string) => string;
interface CreateReportTabsOptions {
	showAbout?: boolean;
}

const createReportTabs = (
	t: Translate,
	{ showAbout = true }: CreateReportTabsOptions = {},
): ITab[] => [
	{
		value: getRoute(['REPORT', 'ACHIEVEMENT']),
		label: t('tabs.achievement'),
		end: false,
	},
	...(showAbout ? [{ value: getRoute(['REPORT', 'ABOUT']), label: t('tabs.aboutMe') }] : []),
];

export default createReportTabs;
